import { useContext } from 'react';
import { DescriptionLink, type DescriptionLinkProps } from '../DescriptionLink';
import { RulesManagerContext } from './RulesManagerContext';

export type RulesManagerSubheaderProps = DescriptionLinkProps;

export const RulesManagerSubheader = ({
  label,
  linkLabel,
  linkUrl,
}: RulesManagerSubheaderProps) => {
  const { onLearnMoreClick } = useContext(RulesManagerContext);

  return (
    <div className="flex">
      <DescriptionLink
        label={label}
        linkLabel={linkLabel}
        linkUrl={linkUrl}
        onLearnMoreClick={onLearnMoreClick}
      />
    </div>
  );
};
